// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://ziuxzberhaeefahingrq.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InppdXh6YmVyaGFlZWZhaGluZ3JxIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTU5NzM3OTAsImV4cCI6MjA3MTU0OTc5MH0.rEXL131yx-VJpe2rkw5Zhx4PwDGBi9OqA1h318GFt7Q";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  },
  db: {
    schema: 'public'
  }
});